import React from 'react';
import { useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';
import '../components/dashboard/DashForm.css';

export default function PlaceholderPage() {
  const { pathname } = useLocation();
  return (
    <div className="dform" style={{ maxWidth: 700, margin: '2rem auto', textAlign: 'center' }}>
      <section className="dform-section" style={{ padding: '3rem 2rem' }}>
        <Construction size={64} style={{ color: 'var(--dash-accent)', marginBottom: '1rem' }} />
        <h2 style={{ margin: '0 0 0.5rem', color: 'var(--dash-ink)' }}>Page en construction</h2>
        <p style={{ color: 'var(--dash-muted)', margin: 0 }}>
          Le module <code style={{ background: 'var(--gray-100)', padding: '0.2rem 0.4rem', borderRadius: 6 }}>{pathname}</code> est en cours de développement.
        </p>
      </section>
    </div>
  );
}
